// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"SectionHeader_sectionHeader__uNu0F","title":"SectionHeader_title__11Shl"};